import { render, staticRenderFns } from "./PersonCardSellsyadmin.vue?vue&type=template&id=1ceb730d&"
import script from "./PersonCardSellsyadmin.vue?vue&type=script&lang=js&"
export * from "./PersonCardSellsyadmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports